/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import EChartsReact from "echarts-for-react";
import moment from "moment";

export interface MultipleYLineProps {
  timeQuantum?: number;
  firstData?: any[];
  secondData?: any[];
  thirdData?: any[];
  style?: React.CSSProperties;
}

export const MultipleYLine: React.FC<MultipleYLineProps> = ({
  timeQuantum,
  firstData,
  secondData,
  thirdData,
  style,
}) => {
  const [MultipleYOption, setMultipleYOption] = useState<any>();
  const [mouthData] = useState([
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ]);
  const [weekData] = useState([
    "周一",
    "周二",
    "周三",
    "周四",
    "周五",
    "周六",
    "周日",
  ]);
  const [xData, setXData] = useState<any>([]);

  useEffect(() => {
    if (timeQuantum === 2) {
      const startIndex = Number(moment().format("M"));
      setXData(
        mouthData.slice(startIndex).concat(mouthData.slice(0, startIndex))
      );
    } else if (timeQuantum === 1) {
      var arr: any = [];
      for (var i = 30; i > 0; i--) {
        const Days = Number(moment().subtract(i, "days").format("DD"));
        if (Days === 1) {
          arr.push(
            mouthData[Number(moment().subtract(i, "days").format("MM")) - 1]
          );
        } else {
          arr.push(Days);
        }
      }
      setXData(arr);
    } else if (timeQuantum === 0) {
      const startIndex = Number(moment().format("E")) - 1;
      setXData(
        weekData.slice(startIndex).concat(weekData.slice(0, startIndex))
      );
    }
  }, [timeQuantum]);

  useEffect(() => {
    let option = {
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["诊疗数", "预警数", "处置数"],
      },
      grid: {
        left: "3%",
        right: "10%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: xData,
        axisLabel: {
          interval: 0,
        },
      },
      yAxis: [
        {
          //第一个y轴位置在左侧
          position: "left",
          type: "value",
          name: "诊疗数",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"],
            lineStyle: {
              color: "#6bc0e1",
            },
          },
        },
        {
          //第二个y轴在右侧
          position: "right",
          type: "value",
          name: "预警数",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"],
            lineStyle: {
              color: "#ee6666",
            },
          },
        },
        {
          //第三个y轴也在右侧，距第二个70个像素
          position: "right",
          offset: 70,
          type: "value",
          // name: "执法数",
          name: "处置数",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"],
            lineStyle: {
              color: "#91cc75",
            },
          },
        },
      ],
      series: [
        {
          name: "诊疗数",
          type: "line",
          color: "#6bc0e1",
          lineStyle: {
            color: "#6bc0e1",
          },
          yAxisIndex: "0", //使用第一个y轴
          data: firstData,
        },
        {
          name: "预警数",
          type: "line",
          color: "#ee6666",
          lineStyle: {
            color: "#ee6666",
          },
          yAxisIndex: "1", //使用第二个y轴，序号从0开始
          data: secondData,
        },
        {
          // name: "执法数",
          name: "处置数",
          type: "line",
          color: "#91cc75",
          lineStyle: {
            color: "#91cc75",
          },
          yAxisIndex: "2", //使用第三个y轴
          data: thirdData,
        },
      ],
    };
    setMultipleYOption(option);
  }, [firstData, secondData, thirdData, xData]);
  return (
    <>
      {MultipleYOption && (
        <EChartsReact option={MultipleYOption} style={style}></EChartsReact>
      )}
    </>
  );
};
